import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useLocation, useNavigate } from "react-router-dom";
import { USERNAME_REGEX } from "../../utils/consts";
import axiosInstance from "../../api/axiosInstance";
import { checkPhoneNumber, loginAsync } from "../../store/slices/authSlice";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../store/hooks";

const SignUp = () => {
  const logoUrl = useAppSelector((state) => state.logo?.logoUrl);
  const logoLoading = useAppSelector((state) => state.logo?.loading);
  const [username, setUsername] = useState("");
  const [phone, setPhone] = useState("");
  const [userErrorMsg, setUserErrorMsg] = useState("");
  const [otp, setOtp] = useState(null);
  const [loading, setLoading] = useState(false);
  const [otpTimer, setOtpTimer] = useState(null);
  const [whatsappOrderId, setWhatsappOrderId] = useState(null);
  const [orderID, setOrderID] = useState("");
  const [validationCode, setValidationCode] = useState();
  const [affiliateCode, setAffiliateCode] = useState("");

  const [otpEnterFields, setOtpEnterFields] = useState(false);
  const [otpErrorMessage, setOtpErrorMessage] = useState("");
  const [phoneNumbeErrorMsg, setPhoneNumbeErrorMsg] = useState("");
  const [phoneNumberValid, setPhoneNumberValid] = useState(false);
  const [country, setCountry] = useState("");
  const [phoneFormat, setPhoneFormat] = useState("");
  const [verificationErrorMsg, setVerificationErrorMsg] = useState("");
  const [signUpErrorMsg, setsignUpErrorMsg] = useState("");
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordErrorMsg, setPasswordErrorMsg] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const goToLogin = () => {
    navigate("/?openLogin=1");
  };
  const [signupSuccess, setSignupSuccess] = useState(false);
  //ref work
  const { search } = useLocation();

  const searchParams = new URLSearchParams(search || "");
  const referralFromQuery = searchParams.get("ref_code");
  const affiliateCodeFromQuery = searchParams.get("aff_code");
  const refCode = referralFromQuery;
  const [referralCode, setReferralCode] = useState(refCode || "");
  const [showReferralCodeField, setShowReferralCodeField] = useState(!!refCode);
  const [showAffiliateCodeField, setShowAffiliateCodeField] = useState(
    !!affiliateCodeFromQuery,
  );

  React.useEffect(() => {
    if (affiliateCodeFromQuery) {
      setAffiliateCode(affiliateCodeFromQuery);
    }
  }, [affiliateCodeFromQuery]);

  const dispatch = useDispatch();

  const validateCaptcha = (captchaValue) => {
    return captchaValue == validationCode;
  };

  const createValidationCode = () => {
    setValidationCode(Math.floor(1000 + Math.random() * 9000));
  };

  const validatePassword = (value) => {
    if (!value) {
      setPasswordErrorMsg("Password is required");
      return false;
    }
    if (value.length < 8) {
      setPasswordErrorMsg("Password must be at least 8 characters long");
      return false;
    }
    if (!/\d/.test(value)) {
      setPasswordErrorMsg("Password must contain at least one number.");
      return false;
    }
    setPasswordErrorMsg("");
    return true;
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
    validatePassword(value);
  };

  const handleOtpTimer = (time) => {
    if (time >= 0) {
      setOtpTimer(time);
      setTimeout(() => {
        handleOtpTimer(time - 1);
      }, 1000);
    } else {
      setTimeout(() => {
        setOtpTimer(undefined);
      }, 1000);
    }
  };

  const checkUserName = async (e) => {
    setsignUpErrorMsg("");
    try {
      const { target } = e;
      const { value } = target;
      if (value.length > 3 && USERNAME_REGEX.test(value)) {
        const response = await axiosInstance.post(`/user/checkUserNameOpen`, {
          user_name: value,
        });

        if (response.msg) {
          if (response?.msg === "Username is available. ") {
            setUserErrorMsg("");
          } else {
            setUserErrorMsg("Username already exists");
          }
        }
      }
    } catch (err) {
      setsignUpErrorMsg("Something went wrong");
    }
  };

  const handlePhoneChange = async (value, countryData, e, formattedValue) => {
    setPhone(value);
    setCountry(countryData);
    setPhoneFormat(formattedValue);
    setPhoneNumbeErrorMsg("");
    setPhoneNumberValid(false);
    setOtpEnterFields(false);

    // reset validity on edit; only format validation is used

    if (!value || !countryData?.format || !formattedValue) {
      return;
    }

    // Validate length matches country format (library-style validation)
    const isFormatValid =
      countryData.format.length === formattedValue.length &&
      value.length >= (countryData.dialCode?.toString().length || 0) + 8;

    if (!isFormatValid) {
      return;
    }

    // Backend "exists" check is skipped (backend issue). If format is valid, enable OTP.
    setPhoneNumberValid(true);
  };

  const sendOTP = async () => {
    setOtpErrorMessage("");
    setIsOtpVerified(false);
    if (!phone) {
      setPhoneNumbeErrorMsg("Please enter a valid phone number.");
      return;
    }
    setLoading(true);
    setPhoneNumbeErrorMsg("");
    try {
      const dialCode = country?.dialCode?.toString() || "";
      const mobileWithoutCode =
        phone && dialCode ? phone.toString().slice(dialCode.length) : phone;

      const payload = {
        country_code: `+${dialCode}`,
        mobile: mobileWithoutCode,
      };

      // axiosInstance interceptor returns response.data directly
      const response = await axiosInstance.post("/whatsapp/send-code", payload);

      if (response?.status) {
        const orderId = response?.data?.orderId || null;
        setWhatsappOrderId(orderId);
        const expiry = response?.otp_expiry_time ?? 60;
        handleOtpTimer(expiry);
        setOtpEnterFields(true);
        setOrderID(orderId || "");
        createValidationCode();
      } else {
        setPhoneNumbeErrorMsg(response?.msg || "");
      }
    } catch (err) {
      setPhoneNumbeErrorMsg(
        err?.response?.data?.message || "Failed to send OTP. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  const verifyOTP = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("/whatsapp/verify", {
        orderId: orderID,
        otp: otp,
      });
      if (!response?.status) {
        setOtpErrorMessage(response?.msg || "");
        setIsOtpVerified(false);
        throw new Error(response?.msg || "");
      }

      setIsOtpVerified(true);
      setOtpErrorMessage("");
    } catch (error) {
      setsignUpErrorMsg(
        error?.response?.data?.message || "Something went wrong",
      );
      setIsOtpVerified(false);
    } finally {
      setLoading(false);
    }
  };

  const handleSignup = async () => {
    if (
      !validatePassword(password) ||
      !isOtpVerified ||
      !phoneNumberValid ||
      userErrorMsg
    ) {
      setsignUpErrorMsg("Please fill all the fields");
      return;
    }
    try {
      setLoading(true);
      const payload = {
        name: username,
        user_name: username,
        password: password,
      };
      console.log(payload);
      if (phone) {
        const dailcode = country?.dialCode?.toString() || "";
        const phoneWithoutCode = phone.toString().slice(dailcode.length);
        payload.mobile = phoneWithoutCode ? phoneWithoutCode : phone;
        payload.country_code = `+${dailcode}`;
      }
      if (referralCode) {
        payload.refer_code = referralCode;
      }
      if (affiliateCode) {
        payload.affiliate_code = affiliateCode;
      }
      try {
        const response = await axiosInstance.post(
          "/user/registerShoutpe",
          payload,
        );
        if (!response?.status) {
          setsignUpErrorMsg(response?.msg || "");
          return;
        }
        setSignupSuccess(true);
        // navigate("/login");
        dispatch(loginAsync({ username, password }));
      } catch (error) {
        setsignUpErrorMsg(error?.response?.msg || "Something went wrong");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signup_modal">
      <div className="signUpUi">
        <div className="container-fluid">
          <div className="row">
            <div
              className="alert alert-success"
              style={{ display: "none" }}
              id="alert"
              role="alert"
            >
              Sign created successfully!
            </div>
            <div className="col-12 text-center pt-3">
              {logoUrl && (
                <img
                  className="img-fluid main-logo"
                  src={
                    logoUrl ||
                    (logoLoading
                      ? ""
                      : "https://speedcdn.io/assets/logos/reddybook.live.png")
                  }
                  style={{ width: "150px" }}
                />
              )}
            </div>
            <div className="pixel"></div>
            <form className="col-sm-12 mx-auto" id="signup_form">
              <div className="form-group">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    id="username"
                    name="username"
                    placeholder="Username 4 To 15 Alphanumeric"
                    value={username}
                    onChange={(e) => {
                      setUsername(e.target.value);
                      checkUserName(e);
                    }}
                  />
                </div>
                {userErrorMsg && (
                  <small className="text-danger">{userErrorMsg}</small>
                )}
              </div>
              <div className="form-group">
                <div className="input-group d-flex align-items-stretch flex-nowrap">
                  <div className="flex-grow-1" style={{ minWidth: 0 }}>
                    <PhoneInput
                      country={"in"}
                      preferredCountries={[
                        "in",
                        "ae",
                        "th",
                        "pk",
                        "np",
                        "lk",
                        "gb",
                      ]}
                      value={phone}
                      onChange={handlePhoneChange}
                      countryCodeEditable={true}
                      containerClassName="mb-0"
                      disabled={userErrorMsg || otpEnterFields}
                      inputClassName="w-100"
                      inputStyle={{
                        width: "100%",
                        backgroundColor: phoneNumberValid
                          ? "#ffffff"
                          : "#d3d3d3",
                      }}
                    />
                  </div>
                  <button
                    type="button"
                    className="btn ms-2 text-nowrap"
                    style={{
                      backgroundColor: !phoneNumberValid
                        ? "#d3d3d3"
                        : "#ffffff",
                      color: "#000000",
                      border: "1px solid #ffffff",
                    }}
                    onClick={sendOTP}
                    disabled={!phoneNumberValid || otpEnterFields}
                  >
                    Send OTP
                  </button>
                </div>
                {phoneNumbeErrorMsg && (
                  <small className="text-danger d-block mt-1">
                    {phoneNumbeErrorMsg}
                  </small>
                )}
                {otpEnterFields && (
                  <small className="text-success d-block mt-1">
                    OTP sent successfully
                  </small>
                )}
              </div>
              <div className="form-group">
                <div className="input-group">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    id="password"
                    name="password"
                    placeholder="Password"
                    value={password}
                    onChange={handlePasswordChange}
                    onBlur={() => validatePassword(password)}
                    aria-describedby="toggle-password-visibility"
                  />
                  <button
                    id="toggle-password-visibility"
                    type="button"
                    className="btn"
                    style={{
                      backgroundColor: "#ffffff",
                      color: "#000000",
                      border: "1px solid #ffffff",
                      zIndex: 1,
                    }}
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={() => setShowPassword((v) => !v)}
                    aria-label={
                      showPassword ? "Hide password" : "Show password"
                    }
                    title={showPassword ? "Hide password" : "Show password"}
                  >
                    {showPassword ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        aria-hidden="true"
                        focusable="false"
                      >
                        <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7S2 12 2 12Z" />
                        <circle cx="12" cy="12" r="3" />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        aria-hidden="true"
                        focusable="false"
                      >
                        <path d="M10.733 5.076A10.744 10.744 0 0 1 12 5c7 0 10 7 10 7a18.893 18.893 0 0 1-3.392 4.916" />
                        <path d="M14.084 14.158A3 3 0 0 1 9.84 9.916" />
                        <path d="M17.479 17.499A10.75 10.75 0 0 1 12 19c-7 0-10-7-10-7a18.827 18.827 0 0 1 4.231-5.568" />
                        <path d="M2 2l20 20" />
                      </svg>
                    )}
                  </button>
                </div>
                {passwordErrorMsg && (
                  <small className="text-danger">{passwordErrorMsg}</small>
                )}
              </div>
              <div className="form-group">
                <div className="d-flex justify-content-between">
                  <button
                    type="button"
                    className="bg-transparent border-0 text-white text-decoration-underline px-0"
                    onClick={() =>
                      setShowReferralCodeField(!showReferralCodeField)
                    }
                  >
                    Have a referral code?
                  </button>
                  <button
                    type="button"
                    className="bg-transparent border-0 text-white text-decoration-underline px-0"
                    onClick={() =>
                      setShowAffiliateCodeField(!showAffiliateCodeField)
                    }
                  >
                    Have an affiliate code?
                  </button>
                </div>

                {showReferralCodeField && (
                  <div className="input-group mt-2">
                    <input
                      type="text"
                      className="form-control"
                      id="referralCode"
                      name="referral_code"
                      placeholder="Referral Code (Optional)"
                      value={referralCode}
                      onChange={(e) => setReferralCode(e.target.value)}
                      disabled={!!refCode}
                    />
                  </div>
                )}

                {showAffiliateCodeField && (
                  <div className="input-group mt-2">
                    <input
                      type="text"
                      className="form-control"
                      id="affiliateCode"
                      name="affiliate_code"
                      placeholder="Affiliate Code (Optional)"
                      value={affiliateCode}
                      onChange={(e) => setAffiliateCode(e.target.value)}
                      disabled={!!affiliateCodeFromQuery}
                    />
                  </div>
                )}
              </div>

              <div className="form-group">
                <div
                  className="custom-control custom-checkbox"
                  style={{ display: "none" }}
                >
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="18_plus"
                  />
                  <label className="custom-control-label" htmlFor="18_plus">
                    I'm over 18 years old.
                  </label>
                </div>
                <div
                  className="custom-control custom-checkbox"
                  style={{ display: "none" }}
                >
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="agree_tnc"
                  />
                  <label className="custom-control-label" htmlFor="agree_tnc">
                    I agree to the Terms&amp;Conditions
                  </label>
                </div>
                <div
                  className="col sm-12"
                  style={{ lineHeight: 1, padding: 0 }}
                >
                  <small>
                    By continuing you will receive a one-time verification code
                    to your phone number by SMS.
                  </small>
                </div>
              </div>
              {otpEnterFields && (
                <div className="form-group mt-2" id="otp_group">
                  <div className="input-group d-flex align-items-stretch flex-nowrap">
                    <input
                      type="text"
                      className="form-control"
                      id="otp"
                      name="otp"
                      placeholder="OTP"
                      value={otp || ""}
                      onChange={(e) => setOtp(e.target.value)}
                    />
                    <button
                      type="button"
                      className="btn ms-2 text-nowrap"
                      style={{
                        backgroundColor:
                          !otp || loading ? "#d3d3d3" : "#ffffff",
                        color: "#000000",
                        border: "1px solid #ffffff",
                      }}
                      disabled={!otp || loading || isOtpVerified}
                      onClick={verifyOTP}
                    >
                      Verify OTP
                    </button>
                  </div>
                  {isOtpVerified && (
                    <small className="text-success d-block mt-1">
                      Otp verified successfully
                    </small>
                  )}

                  {otpErrorMessage && !isOtpVerified && (
                    <small className="text-danger">{otpErrorMessage}</small>
                  )}

                  {!isOtpVerified && (
                    <>
                      {otpTimer !== undefined && otpTimer > 0 ? (
                        <div
                          className="mt-2"
                          id="timer-div"
                          style={{ color: "red" }}
                        >
                          Resend OTP in :{" "}
                          <span id="timer">
                            {String(Math.floor(otpTimer / 60)).padStart(2, "0")}
                            :{String(otpTimer % 60).padStart(2, "0")}
                          </span>
                        </div>
                      ) : (
                        <button
                          type="button"
                          className="btn bg-white text-black w-100 mt-4"
                          onClick={sendOTP}
                        >
                          RESEND OTP
                        </button>
                      )}
                    </>
                  )}
                </div>
              )}
              <button
                type="button"
                className="btn btn-primary mt-1"
                id="send_otp"
                disabled={!isOtpVerified || loading}
                onClick={handleSignup}
              >
                Signup
              </button>
              {signUpErrorMsg && (
                <small className="text-danger text-center">
                  {signUpErrorMsg}
                </small>
              )}
              <button
                type="button"
                className="btn btn-primary mb-5"
                id="signup_submit"
                style={{ display: "none" }}
              >
                Signupsss
              </button>
            </form>
            <div className="signUpNew_info">
              <span>Already have account? </span> &nbsp;
              <a
                href="/"
                onClick={(e) => {
                  e.preventDefault();
                  goToLogin();
                }}
              >
                Log In
              </a>
            </div>
            <div className="loading-div" style={{ display: "none" }}>
              <div className="loading"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
